import DateFnsUtils from '@date-io/date-fns';
import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormDate } from 'types/cms';

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

const DateInput = ({
  control,
  identifier,
  label,
  default_date,
  default_to_current_date,
  min,
  max,
}: FormDate & { control: Control }) => {
  return (
    <Controller
      control={control}
      name={identifier}
      defaultValue={default_to_current_date ? new Date() : default_date ? default_date : new Date()}
      render={({ onChange, value }) => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            fullWidth
            variant="inline"
            label={label ? label : identifier}
            value={value}
            minDate={min}
            maxDate={max}
            onChange={date => {
              date && onChange(date);
            }}
          />
        </MuiPickersUtilsProvider>
      )}
    />
  );
};

export default DateInput;
